// extracted by mini-css-extract-plugin
export default {"_container":"VehiclePicker__container__bqkwb","customSpz":"VehiclePicker_customSpz__fjvKz"};